import React from 'react';
import ServiceDetailPage from '../../components/ServiceDetailPage';
import TallyFlow from './TallyFlow';
import tallyBannerImage from './assets/tally-banner.jpeg';

const TallySolutions = () => {
  return (
    <>
      <ServiceDetailPage
        pageTitle="Tally Solutions"
        breadcrumbLabel="Tally"
        lead="Automate payment reminders and account communication directly from Tally."
        paragraphs={[
          'Connect Tally Prime or ERP 9 with SMS and WhatsApp to send invoice alerts, due reminders, and receipt confirmations automatically.',
          'Your accounts team can reduce manual follow-up and improve collections with event-based communication rules.',
          'Setup is lightweight and designed for fast onboarding without changing your existing accounting workflow.'
        ]}
        benefits={[
          'Automated invoice and outstanding reminders',
          'SMS and WhatsApp messaging from Tally events',
          'Works with Tally Prime and ERP 9',
          'Quick implementation with guided setup'
        ]}
        heroImage={tallyBannerImage}
        ctaText="Get Tally Integration Demo"
        ctaHref="/contact"
      />
      <TallyFlow />
    </>
  );
};

export default TallySolutions;